import React from 'react';
const facts = [{
  value: '161',
  label: 'Bench Cards'
}, {
  value: '6 + 5',
  label: 'Volumes & bonuses'
}, {
  value: '31',
  label: 'Shop worksheets'
}, {
  value: '4',
  label: 'Gates, one fixed order'
}];

// Colores de las Gates del producto
const accents = ['before:bg-patrol-mustard', 'before:bg-ember', 'before:bg-sky', 'before:bg-moss'];
export function SocialProofBar() {
  return <section className="w-full bg-forest-deep" data-id="element-325" data-mp="32jcyak2zl8ew">
      <div className="mx-auto max-w-6xl px-5 pb-12 sm:pb-16" data-id="element-326" data-mp="32h0j2eom5c5j">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-forest-line bg-forest-line sm:grid-cols-4" data-id="element-327" data-mp="2xl33wbp36buc">
          {facts.map((fact, i) => <div key={fact.label} className={`relative bg-forest-deep px-4 py-5 text-center before:absolute before:inset-x-0 before:top-0 before:h-1 before:content-[''] ${accents[i]}`} data-id="element-328" data-mp="2ojlmmpzy0442" data-mpi={i}>
              <div className="font-display text-4xl leading-none text-ember sm:text-5xl" data-id="element-329" data-mp="1d359527y7xju">
                {fact.value}
              </div>
              <div className="mt-1.5 text-[10px] font-bold uppercase tracking-widest text-paper/65" data-id="element-330" data-mp="18m891ht63rp6">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}